import {useState} from 'react'
import {useTripsContext} from './useTripsContext'
import { useAuthContext } from '../hooks/useAuthContext'

export const useNewTrip = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const {user} = useAuthContext()
    const {dispatch} = useTripsContext()

    const newTrip = async (tripName, startDate, endDate) => {
        if (!user) {
            setError('You must be logged in')
            return false
        }
        setIsLoading(true)
        setError(null)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({trip_name: tripName, trip_start_date: startDate, trip_end_date: endDate}),
            credentials: 'include'
        })
        const json = await response.json()

        if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
            setIsLoading(false)
            setError(json.error)
            return false
        }
        if (response.ok) {
            dispatch({type: 'CREATE_TRIP', payload: json})
            setIsLoading(false)
            return true
        }
    }

    return ({newTrip, isLoading, error})
}